import { Agenda } from 'models/agenda';
import { BasicEmployee } from 'models/employee';

import { AGENDA_STATUSES } from 'constants/ProjectConstants';
import { generateKey } from 'constants/helper';

export const AGENDA_OWNERS_UPDATE = 'AGENDA_OWNERS_UPDATE';
export const AGENDA_OWNERS_REMOVE = 'AGENDA_OWNERS_';
export const AGENDAS_REDUCER_ADD = 'AGENDAS_REDUCER_ADD';
export const AGENDAS_REDUCER_UPDATE = 'AGENDAS_REDUCER_UPDATE';
export const AGENDAS_REDUCER_REMOVE = 'AGENDAS_REDUCER_REMOVE';
export const AGENDAS_REDUCER_REMOVE_NEW_AGENDA = 'AGENDAS_REDUCER_REMOVE_NEW_AGENDA';
export const AGENDA_UPDATE = 'AGENDA_UPDATE';
export const AGENDA_ADD_TO = 'AGENDA_ADD_TO';
export const AGENDA_REMOVE_TO = 'AGENDA_REMOVE_TO';
export const AGENDA_ENABLE_EDITING = 'AGENDA_ENABLE_EDITING';
export const AGENDA_DISABLE_EDITING = 'AGENDA_DISABLE_EDITING';
export const AGENDA_UPDATE_TEAM = 'AGENDA_UPDATE_TEAM';
export const AGENDA_TOGGLE_COMPLETION = 'AGENDA_TOGGLE_COMPLETION';

export function addAgendaAction(agenda, addType = 'prepend') {
  return { type: AGENDAS_REDUCER_ADD, agendas: [agenda], addType };
}

export function addAgendasAction(agendas, addType = 'append') {
  return { type: AGENDAS_REDUCER_ADD, agendas, addType };
}

export function addNewAgendaAction(loggedInEmployee, addType) {
  const { id, designation, displayName, profilePhotoSrc } = loggedInEmployee;

  const newAgenda = new Agenda({
    uuid: null,
    text: '',
    status: AGENDA_STATUSES.active,
    macros: null,
    uiKey: generateKey(7),
    fromEmployee: new BasicEmployee({
      id,
      displayName,
      designation,
      profilePhotoSrc,
    }),
    label: null,
  });

  newAgenda.isEditing = true;
  return addAgendaAction(newAgenda, addType);
}

// TODO: remove this
export function updateAgendasAction(agendas) {
  return { type: AGENDAS_REDUCER_UPDATE, agendas };
}

export function removeAgendaAction(agendaId, key) {
  return { type: AGENDAS_REDUCER_REMOVE, data: { agendaId, key } };
}

// TODO: remove this
export function discardNewAgendaAction() {
  return { type: AGENDAS_REDUCER_REMOVE_NEW_AGENDA };
}

export function updateAgendaAction(agenda) {
  return { type: AGENDA_UPDATE, data: { agendaId: agenda.uuid, key: agenda.uiKey, agenda } };
}

// TODO: remove this
export function updateAgendaEditorStateAction({ agendaId, key, editorState }) {
  return { type: AGENDA_UPDATE, data: { agendaId, key, agenda: { editorState } } };
}

// TODO: remove this
export function updateAgendaToIdsAction({ agendaId, key, toIds }) {
  return { type: AGENDA_UPDATE, data: { agendaId, key, agenda: { toIds } } };
}

// TODO: remove this.
export function updateAgendaSubObjectiveAction({ agendaId, key, subObjective }) {
  return { type: AGENDA_UPDATE, data: { agendaId, key, agenda: { subObjective } } };
}

// TODO: remove this.
export function markAgendaCompleteAction({ agendaId, key }) {
  return { type: AGENDA_TOGGLE_COMPLETION, data: { agendaId, key } };
}

// TODO: remove this.
export function toggleCompletionAction({ agendaId, key }) {
  return { type: AGENDA_TOGGLE_COMPLETION, data: { agendaId, key } };
}

// TODO: remove this.
export function markAgendaIncompleteAction({ agendaId, key }) {
  // return { type: AGENDA_UPDATE, data: { agendaId, key, agenda: { completionDate: null } } };
  return { type: AGENDA_TOGGLE_COMPLETION, data: { agendaId, key } };
}

export function enableAgendaEditingAction({ agendaId, key }) {
  return { type: AGENDA_ENABLE_EDITING, data: { agendaId, key } };
}
// agenda is optional here
export function disableAgendaEditingAction({ agendaId, key, agenda }) {
  return { type: AGENDA_DISABLE_EDITING, data: { agendaId, key, agenda } };
}

// TODO: remove this.
export function enableAgendaUpdatingAction({ agendaId, key }) {
  return { type: AGENDA_UPDATE, data: { agendaId, key, agenda: { isUpdating: true } } };
}
// agenda is optional here
// TODO: remove this.
export function disableAgendaUpdatingAction({ agendaId, key, agenda }) {
  return { type: AGENDA_UPDATE, data: { agendaId, key, agenda: { isUpdating: false } } };
}
